export default __webpack_public_path__ + "static/Rhyme7-51bd718945d6c2569c7112492c62d66f.mp3";